export default __webpack_public_path__ + "locales/fr/DeleteThirdPartyDialog.json?hash=5a7fb94278c0132819c457aeb61b6eb6";